import { LoggingService } from './logging.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private SERVER_URL: string;
  private FAKE_SERVER_URL = 'http://localhost:3004/';
  constructor(
    private httpClient: HttpClient,
    private loggingService: LoggingService
  ) {}

  public setAPIEndPoint(url: string): void {
    this.SERVER_URL = url;
  }

  public handleError = (error: HttpErrorResponse) => {
    let errorMessage: any = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = error.error;
    }
    this.loggingService.logException(error);
    return throwError(errorMessage);
  };

  public postData(url, data): Observable<any> {
    return this.httpClient
      .post(`${this.SERVER_URL}${url}`, data)
      .pipe(catchError(this.handleError));
  }

  public fetchData(ep): Observable<any> {
    const url = `${this.SERVER_URL}${ep}`;
    //console.log(url);
    return this.httpClient.get(url).pipe(catchError(this.handleError));
  }

  public fakePostData(url, data): Observable<any> {
    return this.httpClient
      .post(`${this.FAKE_SERVER_URL}${url}`, data)
      .pipe(catchError(this.handleError));
  }

  public fakeFetchData(url): Observable<any> {
    return this.httpClient
      .get(`${this.FAKE_SERVER_URL}${url}`)
      .pipe(catchError(this.handleError));
  }
}
